import styled from "styled-components";

const TextInputContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;

  padding: 15px 20px 10px;

  min-width: max-content;
  width: ${({ width }) => (width ? width : "200px")};

  color: var(--text);
  border-bottom: 2px solid var(--primary);

  &::placeholder {
    color: var(--label);
  }
`;

const TextInput = ({ value, setValue, placeholder, type, width, icon }) => {
  return (
    <TextInputContainer width={width}>
      {icon ? icon : null}
      <input
        type={type || "text"}
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
    </TextInputContainer>
  );
};

export default TextInput;
